import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  list: []
};

const gwaManageListSlice = createSlice({
  name: 'gwaManageList',
  initialState,
  reducers: {
    getgwaManageList: (state, action) => {
      state.list = action.payload;
    }
  }
});

export const { getgwaManageList } = gwaManageListSlice.actions;
export default gwaManageListSlice.reducer;
